import { type PlayableType } from "../../global/types/GlobalTypes";
import { type Division } from "../../playable/models/Division";

export type TimelinePartEventTypes = 'low_rate_refresh' | 'high_rate_refresh' | 'metronome' | 'audio' | 'meta' | 'countdown_stop'
export type TimelinePartEventMetaTypes = 'start' | 'end'
export type AudioTimelinePartEventVoices = 'melody' | 'piano_left' | 'piano_right'

export interface TimelinePartEvents {
  divisionId: number,
  events: TimelinePartEvent[],
  time: string
}

export interface BaseTimelinePartEvent {
  divisionId: number;
  type: Exclude<TimelinePartEventTypes, 'audio' | 'meta'>;
}

export interface AudioTimelinePartEvent {
  divisionId: number;
  type: 'audio'
  key: number[]
  noteNames: string[]   // pre-mapped via KEYS_TO_NOTES at load time — avoids per-tick .map()
  durations: string[],
  voice: AudioTimelinePartEventVoices,
}

export interface MetaTimelinePartEvent {
  divisionId: number;
  type: 'meta'
  metaEvent: TimelinePartEventMetaTypes
  playableType: PlayableType
}

export type TimelinePartEvent = BaseTimelinePartEvent | AudioTimelinePartEvent | MetaTimelinePartEvent

export type PlayerStatus = 'pause' | 'countdown' | 'play' | 'player_controlled'

export interface AudioPlayerState {
  baseTempo: number
  tempo: number
  divisionPerBeat: number
  beatPerMeasure: number
  timer: number
  playerStatus: PlayerStatus
  currentDivision: null | Division,
  divisionDuration: number,
  isLoading: boolean,
  error: boolean
}

export const defaultAudioPlayerState: AudioPlayerState = {
  baseTempo: 120,
  tempo: 120,

  divisionPerBeat: 4,
  beatPerMeasure: 4,

  timer: 0,
  playerStatus: 'pause',
  currentDivision: null,
  divisionDuration: 0,
  isLoading: false,
  error: false
}
